<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uoU0fZ/tc-custom/9781426861628.jpg?1740871333929" alt="This image is the cover for the book In the King's Service"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the King's Service
      </h1>
      <p class="bookDescription body article font2">
        <p>'Twas said he could whisper a woman to bed, and now Sir BlaiddMorgan had turned his considerable charms on Lady Becca Throckton. Butcould she trust his intent? A childhood injury had made her fit to beno man's bride, and yet the Welsh warrior made her feel she'd a rightto her woman's heart!The Lady Becca surprised him, and that was rare, Sir Blaidd mused.Indeed, she had a fire that stirred him in unexpected ways. Though hecould ill afford a dalliance on this secret mission for his king, hefound himself entranced. Surely this was no mere idyll. Nay, this hadthe feel of forever…!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Moore
      </h2>
      
      <p class="authorDescription body article"><p>An award-winning author of over sixteen historical romance novels, Margaret began her career at the age of eight when she concocted stories featuring a lovely damsel and a handsome, misunderstood thief. She's had a soft spot for handsome, misunderstood rogues ever since.</p><p>Unknowingly pursuing her destiny, Margaret graduated with distinction from the University of Toronto with a Bachelor of Arts degree in English Literature. She also demonstrated a facility for language by winning the Winston Churchill Silver Medal for public speaking. She now utilizes this gift of the gab by giving workshops for various writing groups, including Romance Writers of America and the Canadian Authors Association.</p><p>A past president of Toronto Romance Writers, Margaret lives in Toronto with her husband, two teenagers and two cats.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35ffec74